// extracted by mini-css-extract-plugin
export default {"modal":"Rha","heading":"Sha","product":"Tha","note":"Uha","notetitle":"Vha","notetext":"Wha","line":"Xha","plan":"Yha","planimage":"Zha","description":"aia"};
    if(module.hot) {
      // 1726593108563
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  